<nz-skeleton [nzActive]="true" [ngClass]="size"
      [nzLoading]="true"
      [nzParagraph]="false"
      [nzAvatar]="{size: 'large', shape: 'square'}">
</nz-skeleton>